/**
 * Utilitario de slug para o cardapio digital.
 *
 * Gera um slug legivel a partir de um texto livre (ex.: o nome de uma
 * categoria ou de um produto), permitindo refletir a selecao na URL pelo NOME
 * em vez do id (ex.: `?categoria=perfume-femenino&item=llaveritos-de-goma`).
 *
 * Segue o mesmo padrao de normalizacao ja usado em
 * `configuracao-mine-shop.component.ts` (slug do nome da loja).
 */

/**
 * Converte um texto livre em um slug:
 * - Remove acentos/diacriticos (normalizacao NFD).
 * - Converte para minusculas.
 * - Substitui qualquer caractere nao alfanumerico por hifen.
 * - Colapsa hifens duplicados e remove hifens das bordas.
 *
 * Exemplos:
 *  - "Perfume Femenino"   -> "perfume-femenino"
 *  - "REMERAS OVER"       -> "remeras-over"
 *  - "Bebidas & Sucos"    -> "bebidas-sucos"
 *  - "LLAVERITOS DE GOMA" -> "llaveritos-de-goma"
 *
 * @param texto Texto de origem (ex.: nome da categoria/produto). Aceita null/undefined.
 * @returns Slug normalizado ou string vazia quando a entrada e vazia.
 */
export function slugificar(texto: string | null | undefined): string {
  if (!texto) return '';
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Slug do nome de uma categoria.
 *
 * Mantido por retrocompatibilidade \u2014 delega para {@link slugificar}, que e o
 * utilitario generico (tambem usado para o nome de produtos). Preferir
 * `slugificar` em codigo novo.
 *
 * @param nome Nome da categoria. Aceita null/undefined.
 * @returns Slug normalizado ou string vazia quando a entrada e vazia.
 */
export function slugificarCategoria(nome: string | null | undefined): string {
  return slugificar(nome);
}
